module.exports = __webpack_public_path__ + "b81db2b4f0cc8edb8127e51e5f216b84.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/manage-application/users/unassign-group/unassign-group.html
// module id = 1621
// module chunks = 0